import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuestionnaireData } from './Hooks/useQuestionnaireData';
import { useQuestionnaireActions } from './Hooks/useQuestionnaireActions';
import { useQuestionnaireUtils } from './Hooks/useQuestionnaireUtils';
import TemplatesProgressBar from './Header/TemplatesProgressBar';
import Questions from '../Questions/Questions';
import BackSection from '../../Services/BackSection';
import css from '../style.module.css';
import SkeletonQuestionsPage from '../../LoadingPages/SkeletonQuestionsPage';
import QuestionnaireHeader from './Header/QuestionnaireHeader';

export default function Questionnaires() {
    const location = useLocation();
    const { questionnaireId, pirm_addon__Status__c, Audits_r } = location.state || {};

    const { groupedSections, rawQuestions, isLoading, error } = useQuestionnaireData(questionnaireId);
    const { submitAnswer, uploadFile, deleteFile, isAnyActionLoading } = useQuestionnaireActions(questionnaireId);
    const { calculateProgress } = useQuestionnaireUtils();

    const [activeSectionIndex, setActiveSectionIndex] = useState(0);
    const [windowIndex, setWindowIndex] = useState(0);

    useEffect(() => {
        if (groupedSections.length > 0 && activeSectionIndex >= groupedSections.length) {
            setActiveSectionIndex(0);
            setWindowIndex(0);
        }
    }, [groupedSections.length]);

    const handleSectionClick = (index) => {
        setActiveSectionIndex(index);
        if (index < windowIndex) {
            setWindowIndex(index);
        } else if (index >= windowIndex + 3) {
            setWindowIndex(index - 2);
        }
    };

    if (isLoading) return <SkeletonQuestionsPage />
    if (error) return <div className="alert alert-danger">Error: {error.message}</div>;

    const currentSectionQuestions = groupedSections[activeSectionIndex] || [];
    const { answered, total } = calculateProgress(rawQuestions);

    return (
        <section className={css.container}>
            <BackSection pageName="Questionnaires" to={"/vendors"} />
            <div className="row">
                <div className="col-12">
                    < QuestionnaireHeader />
                    <TemplatesProgressBar
                        sections={groupedSections}
                        activeSectionIndex={activeSectionIndex}
                        windowIndex={windowIndex}
                        onSectionClick={handleSectionClick}
                        onNext={() => setWindowIndex(prev => prev + 1)}
                        onPrev={() => setWindowIndex(prev => prev - 1)}
                    />

                    <Questions
                        questionnaireId={questionnaireId}
                        questionnaire={currentSectionQuestions.filter(item => item.pirm_addon__IsApplicable__c)}
                        allQuestions={rawQuestions}
                        position={activeSectionIndex}
                        Audits_r={Audits_r}
                        pirm_addon__Status__c={pirm_addon__Status__c}
                        onUpdateAnswer={submitAnswer}
                        onUploadFile={uploadFile}
                        onDeleteFile={deleteFile}
                        isSaving={isAnyActionLoading}
                        // توحيد المسميات هنا ليطابق الـ Child
                        theAnsweredQuestions={answered}
                        theTotalQuestions={total}
                        handleClick={handleSectionClick}
                        questionnaireLength={groupedSections.length}
                    />
                </div>
            </div>
        </section>
    );
}